<template>
  <div class="loadingSpinnerBar col-12 mt-4 pt-4" >
      <small v-if="loadingText" class="text-primary">{{loadingText}}</small>
        <div class="linear-progress">
            <div class="bar bar1"></div>
            <div class="bar bar2"></div>
        </div>
        <img src="@/assets/images/logo-h.png" class="logooliver" />
  </div>
</template>
<script>


export default {

  data() {
    return {
      loadingText: false
    };
  },
  created() {
    setTimeout(() => {
            this.loadingText = this.$t('lang.search.loadingproblem');
          
        }, 5000);

  }
 
};
</script>
<style>
.logooliver{
  width:80px;
  margin:0 auto;
}
</style>